import { takeLatest, call, put, select } from 'redux-saga/effects';
import axiosInstance from '../../services/AuthHeader';
import { setSending, unsetSending } from '../reducers/serverCommunication';
import {
  clearProfileFailure,
  selectUserId,
  setProfile,
  setProfileFailure,
} from '../reducers/session';

export const SAGA_UPDATE_PATIENT = 'SAGA_UPDATE_PATIENT';

export function sendUpdateProfile({
  nickname,
  birthYear,
  province,
  phone,
  language,
  uiMode,
  isEmailReminder,
  isTextReminder,
  studyCode,
  hiddenCards,
}) {
  const payload = {
    nickname,
    birthYear,
    province,
    phone,
    language,
    uiMode,
    isEmailReminder,
    isTextReminder,
    studyCode,
    hiddenCards,
  };
  return { type: SAGA_UPDATE_PATIENT, payload };
}

const handleUpdateProfile = async ({
  userId,
  language,
  uiMode,
  isEmailReminder,
  isTextReminder,
  nickname,
  birthYear,
  province,
  phone,
  studyCode,
  hiddenCards,
}) =>
  axiosInstance
    .put('/api/users/' + userId + '/profile', {
      nickname,
      birthYear,
      province,
      phone,
      language,
      uiMode,
      isEmailReminder,
      isTextReminder,
      studyCode,
      hiddenCards,
    })
    .then((res) => res.data);

export function* updatePatient(action) {
  yield put(setSending);
  // Clear any errors.
  yield put(clearProfileFailure());
  try {
    let userId = yield select(selectUserId);
    // Inject the userid id into the payload.
    action.payload.userId = userId;
    const response = yield call(handleUpdateProfile, action.payload);
    yield put(setProfile(response.profile));
  } catch (error) {
    if (error.response.status === 400 && error?.response?.data?.errors) {
      yield put(setProfile(error.response.data.profile));
      yield put(setProfileFailure(error.response.data.errors));
    } else {
      yield put(setProfileFailure(error.response));
    }
  } finally {
    yield put(unsetSending);
  }
}

export function* watchForUpdateProfile() {
  yield takeLatest(SAGA_UPDATE_PATIENT, updatePatient);
}
